export const services = [
  {
    id: 1,
    name: "Program Management",
    link: "/our-services#program-management",
    description:
      "Our program management consulting services are designed to guide you through every stage of your projects. From program design to risk management and performance evaluation, our dedicated team provides expertise and support. Streamline your processes and achieve exceptional results with our user-friendly platform and comprehensive resources.",
    image: "/images/program.png",
  },
  {
    id: 2,
    name: "Impact Assessment",
    link: "/our-services#impact-assessment",
    description:
      "Our experts help you to measure and understand the effects of your organization's initiatives with our comprehensive impact assessment services. Our experts employ robust methodologies to gather data, analyze results, and provide actionable insights. Demonstrate the value and outcomes of your efforts with our evaluation, survey, and performance indicator services.",
    image: "/images/ai.jpeg",
  },
  {
    id: 3,
    name: "Research",
    link: "/our-services#research",
    description:
      "Our research services cover diverse areas, delivering comprehensive studies utilizing industry-standard methodologies. Whether internal migration, climate change, sustainability, or other critical topics, our efficient team of researchers and academics ensures high-quality results.",
    image: "/images/research.jpg",
  },
  {
    id: 4,
    name: "Monitoring and Evaluation",
    link: "/our-services#monitoring-and-evaluation",
    description:
      "Our holistic approach to monitoring and evaluation helps you assess and track project progress. With data collection, analysis, and performance measurement expertise, we provide valuable insights for evidence-based decision-making. From establishing monitoring frameworks to conducting evaluations, our services drive impactful results.",
    image: "/images/monitoring.png",
  },
  {
    id: 5,
    name: "Documentation and Registration",
    link: "/our-services#documentation-and-registration",
    description:
      "We assist clients from diverse backgrounds in vital documentation processes and compliances. From country-specific legal compliance review to registration and renewal, our services ensure your documentation needs are met efficiently and effectively.",
    image: "/images/documentation.jpg",
  },

  {
    id: 6,
    name: "CSR Services",
    link: "/our-services#csr-services",
    description:
      "Align your CSR strategies with business goals and design sustainable community engagement programs with our comprehensive support. From proposal screening tools to capacity building and training, we help organizations develop impactful corporate social responsibility initiatives.",
    image: "/images/CSR-Baseline-Assessment.webp",
  },
  {
    id: 7,
    name: "CFO Services",
    link: "/our-services#cfo-services",
    description:
      "Our CFO services offer strategic financial leadership and expertise, enabling sound decision-making across budgeting, risk management, and financial planning. Overcome financial obstacles and achieve long-term growth with our fund utilization review, compliance assessment, and internal audit services.",
    image: "/images/cfo.jpg",
  },
  {
    id: 8,
    name: "HR and Talent Advisory",
    link: "/our-services#hr-and-talent-advisory",
    description:
      "Enhance your company's human resources policies with our HR and Talent Advisory services. From talent acquisition to performance management, we provide comprehensive support to develop a strong workforce and foster a positive workplace culture aligned with your corporate goals.",
    image: "/images/hr.jpeg",
  },
  {
    id: 9,
    name: "Climate Resilience & Innovation",
    link: "/our-services#climate-resilience-and-innovation",
    description:
      "SoulScale provides technical and implementation support for worker-centric climate adaptation - including heat resilience, cooling centres, hydration systems, climate-risk insurance, resilient housing, and climate-responsive social protection. We help partners design, pilot and scale practical, evidence-based solutions for informal and migrant workers.",
    image: "/images/climate-change.webp",
  },
  // {
  //   id: 9,
  //   name: "Resilience Connect",
  //   link: "/our-services#resilience-connect",
  //   description:
  //     "Our innovative mobile application, coupled with a robust web portal, empowers organizations to efficiently register respondents and identify their eligibility for various initiatives. Designed for seamless tracking, this solution enables users to identify,  monitor, and manage program applications with ease. Simplify your processes and focus on delivering impact with our cutting-edge platform.",
  //   image: "/images/placeholder.svg",
  // },
];
